import { SxProps, Theme } from "@mui/material";

export const drawerWidth = 260;

export const drawerSx: SxProps<Theme> = {
  width: drawerWidth,
  flexShrink: 0,
  [`& .MuiDrawer-paper`]: {
    width: drawerWidth,
    boxSizing: "border-box",
    overflowX: "hidden",
    transition: "width 0.3s",
    backgroundColor: "#253c63",
    color: "#fff",
  },
};

export const drawerClosedSx: SxProps<Theme> = {
  ...drawerSx,
  width: 60,
  [`& .MuiDrawer-paper`]: {
    ...(drawerSx["& .MuiDrawer-paper"] as Record<string, any>),
    width: 60,
  },
};

export const logoBoxSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  cursor: "pointer",
};

export const listItemButtonSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  p: 2,
  "&:hover": {
    backgroundColor: "#525f7f",
  },
};

export const listItemIconSx: SxProps<Theme> = {
  color: "#fff",
  minWidth: 0,
  mr: 2,
  justifyContent: "center",
};

export const ListItemTextSx: SxProps<Theme> = {
  color: "#fff",
  whiteSpace: "nowrap",
};

export const dividerSx: SxProps<Theme> = {
  borderColor: "rgba(255,255,255,0.2)",
};
